import React, { Component } from 'react';

import { Box, Typography } from '@mui/material';

import { black, colors } from 'constants/colors';

import { styles } from './styles';

interface Props {
  children: React.ReactNode;
  mode: 'light' | 'dark';
}

interface State {
  hasError: React.ReactNode;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any) {
    console.error(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            ...styles.errorContainer,
            backgroundColor:
              this.props.mode === 'dark' ? black.main : colors.MAIN_GRAY,
          }}
        >
          <Typography sx={styles.errorTitle}>Ups, algo salió mal</Typography>
          <Typography>
            Parece que hubo un error al intentar carga la página. Inténtalo
            nuevamente.
          </Typography>
        </Box>
      );
    }
    return this.props.children;
  }
}
